import { render } from "./OtherQuery.vue?vue&type=template&id=3a9de713&class=text-center"
import script from "./OtherQuery.vue?vue&type=script&lang=js"
export * from "./OtherQuery.vue?vue&type=script&lang=js"

import "./OtherQuery.vue?vue&type=style&index=0&id=3a9de713&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__